export default {
  dashboard: 'Ana Ekran',
  liveScreen: 'Canlı İzleme',
  liveScreenOrder: 'Sipariş İzleme',
  performanceInfo: 'Performans Bilgileri',
  liveTracking: {
    title: 'Canlı İzleme',
    courierPerformanceDashboard: 'Dağıtcı Performans Dashboard',
    liveScreen: 'Canlı İzleme',
  },
  orderManagement: {
    title: 'Sipariş Yönetimi',
    orders: 'Siparişler',
    ordersPendingAction: 'Aksiyon Bekleyen Siparişler',
    ordersWaitingTransfer: 'Transfer Bekleyen Siparişler',
    orderMapAnalysis: 'Sipariş Analizi',
    storeCourierSourceResource: 'Sipariş Dağıtıcı Yönetimi',
  },
  zoneManagement: {
    title: 'Zone ve Slot Yönetimi',
    zones: 'Zonelar',
    bulkZoneUpdate: 'Toplu Zone Güncelleme',
    templateManagement: 'Şablon Yönetimi',
    templateZoneMatching: 'Şablon Zone Eşleştirme',
    slotMonitoring: 'Slot İzleme',
    bulkSlotUpdate: 'Toplu Slot Güncelleme',
  },
  bonusManagement: {
    title: 'Prim Yönetimi',
    carPool: 'Araç Havuzu',
    bonusDefinitions: 'Prim Tanımları',
    bonusComponents: 'Prim Bileşenleri',
    bonusRules: 'Prim Kuralları',
    bonusCalculationScreen: 'Prim Hesaplama Ekranı',
    courierPayCut: 'Dağıtıcı Kesinti Bildirimi',
    vehicleWorkHours: 'Araç Çalışma Takvimi',
  },
  fleetManagement: {
    title: 'Filo Yönetimi',
    vehicles: 'Araçlar',
    vehicleGroups: 'Araç Grupları',
    couriers: 'Dağıtıcılar',
    courierGroups: 'Dağıtıcı Grupları',
    couriersAwaitingApproval: 'Onay Bekleyen Dağıtıcılar',
    courierApplicationList: 'Esnaf Kurye Başvuruları',
  },
  customerManagement: {
    title: 'Müşteri Yönetimi',
    customers: 'Müşteriler',
    addresses: 'Adresler',
    zones: 'Zonlar',
  },
  routeManagement: {
    title: 'Rotalama Yönetimi',
    routePlan: 'Rota Planlama',
    routeMonitoringList: 'Rota Listeleme',
    routeMonitoring: 'Rota Detay',
  },
  dynamicCapacityManagement: {
    title: 'Dinamik Kapasite Yönetimi',
    dynamicCapacity: 'Dinamik Kapasite',
  },
  reports: {
    title: 'Raporlar',
    endOfDayReport: 'Gün Sonu Raporu',
    courierShiftReport: 'Dağıtıcı Mesai Raporu',
    courierDistanceReport: 'Dağıtıcı Mesafe Raporu',
    orderStatusReport: 'Sipariş Durum Raporu',
  },
  definitions: {
    title: 'Tanımlar',
    citiesServed: 'Hizmet Verilen Şehirler',
    distributionCenters: 'Dağıtım Merkezleri',
    zones: 'Zonelar',
    routingParameterProfiles: 'Rotalama Parametre Profilleri',
    routingParameters: 'Rotalama Parametreleri',
    penalty: 'Rotalama Parametre Değerleri',
    users: 'Kullanıcılar',
    publicHolidays: 'Resmi Tatiller',
    firms: 'Firmalar',
    regions: 'Bölgeler',
    bulkDefinitionTracing: 'Toplu Tanım İzleme',
    massNotification: 'Toplu Bilgilendirme Oluşturma',
  },
  storeManagement: {
    title: 'Mağaza Yönetimi',
    stores: 'Mağazalar',
    storeBasedSectionSort: 'Mağaza Bazlı Reyon Sıralama',
    storeGroups: 'Şubeler',
    waitingApproveStores: 'Onay Bekleyen Mağazalar',
  },
  productManagement: {
    title: 'Ürün Yönetimi',
    orderItemProperties: 'Gramajlı Ürünler',
    partialDeliveryApproval: 'Eksik Toplama Onayı',
    cancelledItemHistory: 'Eksik Toplanan Ürün Stok Kontrolü',
  },
  parameters: {
    title: 'Parametreler',
    parameterSettings: 'Ayarlar',
  },
  routingManagement: {
    title: 'Rotalama Yönetimi',
    routingViewList: 'Rota Listeleme',
    routingDetail: ' Rota Detay',
    routingPlanning: 'Rota Planlama',
  },
  progressPaymentSystem: {
    title: 'Hakediş Sistemi',
    progressPaymentTemplates: 'Hakediş Şablonları',
    progressPaymentStatusTracking: 'Hakediş Durum Takip',
    progressPaymentTemplateByStore: 'Mağaza Eşleşmeleri',
  },
  storeTask: {
    title: 'Mağaza Çizelgeleme',
    storeTaskTemplate: 'Çizelge Şablonları',
  },
  stockManagement: {
    title: 'Stok Yönetimi',
    stockTrackingScreen: 'Stoklar',
    stockTransactions: 'Stok Hareketleri',
  },
  settings: {
    title: 'Ayarlar',
    myProfile: 'Profilim',
  },
};
